import type { Token } from "../types";
import type { PriceFrame } from "../lib/priceFrame";

import { useState } from "react";

export function TokenIcon({ token }: { token: Token }) {
  const imageKey = `${token.mint}:${token.imageUrl ?? ""}`;
  const [failedImage, setFailedImage] = useState<string>();
  const failed = failedImage === imageKey;
  return (
    <span
      className={`token-icon${!token.imageUrl || failed ? " unknown" : ""}`}
      title={`${token.symbol}: ${token.mint}`}
      aria-label={token.symbol}
    >
      {token.imageUrl && !failed ? (
        <img
          src={token.imageUrl}
          alt=""
          onError={() => {
            setFailedImage(imageKey);
          }}
          referrerPolicy="no-referrer"
        />
      ) : (
        "?"
      )}
    </span>
  );
}

export function TokenSymbol({ token }: { token: Token }) {
  return (
    <a
      className="token-link"
      href={`/api/tokens/${encodeURIComponent(token.mint)}/link`}
      target="_blank"
      rel="noopener noreferrer"
      title={`Research ${token.symbol}; destination is selected automatically from verified token metadata`}
    >
      {token.symbol}
    </a>
  );
}

/** Takes a frame, never a raw token order, so the pair always reads in the display orientation. */
export function TokenPairName({ frame }: { frame: PriceFrame }) {
  return (
    <>
      <TokenSymbol token={frame.base} /> / <TokenSymbol token={frame.quote} />
    </>
  );
}

export function TokenPair({ frame }: { frame: PriceFrame }) {
  return (
    <span className="token-pair-icons" aria-hidden="true">
      <TokenIcon token={frame.base} />
      <TokenIcon token={frame.quote} />
    </span>
  );
}
